import { useContext, useMemo } from "react";
import {
  filterEntityEnum,
  type FilterEntity,
} from "../FilterManagement/filterEntity";
import {
  CH_REPORT_TYPE,
  DEFAULT_REPORT_TYPE,
  RESOURCES_REPORT_TYPE,
} from "./DownloadReportApi";
import { AppPreferencesContext } from "../../General/AppPreferencesProvider";

type ReportType =
  | typeof CH_REPORT_TYPE
  | typeof DEFAULT_REPORT_TYPE
  | typeof RESOURCES_REPORT_TYPE;

interface UseReportParamsReturn {
  reportType: ReportType | null;
}

const useReportParams = (entityType: FilterEntity): UseReportParamsReturn => {
  const {
    appPreferences: { useClickhouse },
  } = useContext(AppPreferencesContext);

  const reportType = useMemo<ReportType | null>(() => {
    switch (entityType) {
      case filterEntityEnum.REMEDIATION_ITEM:
        return useClickhouse ? CH_REPORT_TYPE : DEFAULT_REPORT_TYPE;

      case filterEntityEnum.RESOURCE:
        return RESOURCES_REPORT_TYPE;

      default:
        return null;
    }
  }, [entityType, useClickhouse]);

  return { reportType };
};

export default useReportParams;
